import { Component, ComponentRef, Type, ViewChild, ViewContainerRef, ElementRef, effect, signal, Input, inject, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { TabComponentLoader } from '@app/common-codes/services/TabComponentLoader.service';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Role, TenantRole } from '@app/common-codes/models/matwins-tenant/Role.model';
import { ManagerRole } from '@app/common-codes/models/matwins-tenant/Role.model';
import { RoleDetailComponent } from '../role-detail/role-detail.component';
import { LookupProfile, LookupService } from '@app/common-codes/services/LookupService';
import { StructuredDataRequest } from '@app/common-codes/_DTOs/IStructuredData';
import { RequirePermissionDirective } from '@app/common-codes/components/directives/RequirePermissionDirective';

@Register(Role)
@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ListViewComponent,
    RoleDetailComponent,
    ListTableColumnComponent,
    TranslatePipe,
    RequirePermissionDirective
]
})
export class RoleListComponent extends GenericListComponent<Role> {
  override Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  override ComponentEntityClass = Role;// = Role;
  override entityMetaData: IEntityMetaData = new Role().GetType();
  private loadedComponents: { [key: string]: ComponentRef<any> } = {};
  override contextMenuItems = [];
  // isModalOpen = signal(false);
  modalEntity = signal<TenantRole | ManagerRole | null>(null);
  @ViewChild('roleDetail', { read: RoleDetailComponent }) roleDetail!: RoleDetailComponent;
  @Input() roleType: 'tenant' | 'manager' = 'tenant';


  public static override get lookupProfiles(): LookupProfile[] {
    const lookupProfiles: LookupProfile[] = [

    ];
    return lookupProfiles;
  }

  constructor(private tabLoader: TabComponentLoader, _alertModalService: AlertModalService, translationService: TranslationService) {
    super();
    this.alertModalService = _alertModalService;
  }

  onSearchInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm.set(value);
    this.listView()?.onSearch(value);
  }

  override async ngOnInit() {
    this.ComponentEntityClass = this.roleType === 'tenant' ? TenantRole : ManagerRole;
    this.entityMetaData = this.roleType === 'tenant' ? TenantRole.getMetaData() : ManagerRole.getMetaData();

    super.ngOnInit();
    // Mettre à jour les métadonnées du repository pour utiliser le bon EndPoint
    const repository = (this.dataService as any).repository;
    if (repository && repository.setMetaData) {
      repository.setMetaData(this.entityMetaData);
    }
    //let yyy = this.RequiredPermissions; // pour test
    //const params: StructuredDataRequest = {
    //  pageNumber: 1,
    //  pageSize: this.listView()?.pageSize() ?? 5,
    //  search: this.searchTerm(),
    //  sortBy: this.listView()?.sortBy(),
    //  sortOrder: this.listView()?.sortOrder(),
    //  combinedSearchColumns: undefined,
    //  requiredLookups: undefined
    //};
    //await this.performLoadData(params, 0, params.pageSize);

  }

  override async ngOnChanges(changes: SimpleChanges) {
    if (changes['roleType'] && changes?.['roleType'].previousValue) {
      const next = changes['roleType'].currentValue as ('tenant' | 'manager') | null | undefined;
      if (next !== 'tenant' && next !== 'manager') return;
      // éviter de relancer si identique
      if (changes['roleType'].previousValue === next) return;
      // réagir au changement
      this.roleType = next;
      this.ComponentEntityClass = this.roleType === 'tenant' ? TenantRole : ManagerRole;
      this.entityMetaData = this.roleType === 'tenant' ? TenantRole.getMetaData() : ManagerRole.getMetaData();
      // Mettre à jour les métadonnées du repository pour utiliser le bon EndPoint
      const repository = (this.dataService as any).repository;
      if (repository && repository.setMetaData) {
        repository.setMetaData(this.entityMetaData);
      }
      const params: StructuredDataRequest = {
        pageNumber: 1,
        pageSize: this.listView()?.pageSize() ?? 5,
        search: this.searchTerm(),
        sortBy: this.listView()?.sortBy(),
        sortOrder: this.listView()?.sortOrder(),
        combinedSearchColumns: undefined,
        requiredLookups: undefined
      };
      await this.performLoadData(params, 0, params.pageSize);
    }
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  override getdetailComponent(): GenetricDetailComponent<Role> | undefined {
    return this.roleDetail;
  }

  override editSelectedItem(selectedItem: Role) {
    this.selectedItem.set(selectedItem);
    this.isModalOpen.set(true);
  }

  override openCreateModal() {
    var emptyEntity = this.roleDetail.getEmptyEntity();

    this.selectedItem.set(emptyEntity);
    this.isModalOpen.set(true);
  }

  // closeModal() {
  //   this.isModalOpen.set(false);
  //   this.selectedItem.set(null);
  // }


  override postAddedItem(updatedItem: Role) {

  }

}

